import React, { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import Navbar from "./components/Navigation";
import { useCartContext } from "./components/CartContext";
/*
 Simple layout with nav. Developer Note: replace with Tailwind components.
*/
export default function App(){
  const { syncOnLogin, isLoggedIn } = useCartContext();

  useEffect(() => {
    if (isLoggedIn) {
      syncOnLogin();
    }
  }, [isLoggedIn]);
return (
    <div className="min-h-screen bg-gradient-to-br from-pink-200 via-blue-200 to-purple-300">
      {/* <LandingPage/> */}
      <Navbar />
      <main className="pt-28 container mx-auto px-6 pb-10">
        <Outlet />
      </main>
    </div>
  );
}
